import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AdminService } from "../../../admin.service";
import { adminActions, adminApiActions } from "../../actions/admin.actions";
import { exhaustMap, map, of, switchMap, tap } from "rxjs";
import { Router } from "@angular/router";
import { concatLatestFrom } from "@ngrx/operators";
import { selectAdminEvent } from "../../selectors/admin.selectors";

@Injectable()
export class AdminEventEffects {
    private action$ = inject(Actions);
    private readonly service = inject(AdminService);
    private readonly store = inject(Store);
    private readonly router = inject(Router);

    updateEventTicket$ = createEffect(() => {
        return this.action$.pipe(
            ofType(adminActions.updateEventTicket),
            concatLatestFrom(action => this.store.select(selectAdminEvent(action.eventTicket.eventID))),
            exhaustMap(([action,lrpEvent]) => 
                this.service.updateEventTicket(action.eventTicket).pipe(
                    map(data => adminApiActions.updatedEventTicket({ update : {
                        changes: {
                            eventTickets: lrpEvent?.eventTickets.map(ticket => ticket.ticketID === data.ticketID ? data : ticket),
                        },
                        id: data.eventID
                    } }))
                )
            )
        )
    })

    insertedEventTicket$ = createEffect(() => {
        return this.action$.pipe(
            ofType(adminActions.addEventTicket),
            concatLatestFrom(action => this.store.select(selectAdminEvent(action.eventTicket.eventID))),
            exhaustMap(([action,lrpEvent]) => 
                this.service.createEventTicket(action.eventTicket).pipe(
                    map(data => adminApiActions.createdEventTicket({ update : {
                        changes: {
                            eventTickets: [...lrpEvent?.eventTickets ?? [], data],
                        },
                        id: data.eventID
                    } }))
                )
            )
        )
    })

    eventCreate$ = createEffect(() => {
        return this.action$.pipe(
            ofType(adminApiActions.eventCreated),
            tap((lrpEvent) => this.router.navigate(['/admin','events',lrpEvent.lrpEvent.eventLink,'details'], {
                queryParams: {
                    show_wizard: true
                }
            }))
        )
    },
    {functional: true, dispatch: false})

    eventUpdated$ = createEffect(() => {
        return this.action$.pipe(
            ofType(adminActions.updateEvent),
            concatLatestFrom(action => this.store.select(selectAdminEvent(action.update.id))),
            exhaustMap(([action,data]) => {
                if (data){
                    return this.service.updateEvent(data).pipe(
                        map(lrpEvent => adminApiActions.eventUpdated({ lrpEvent }))
                    )
                }
                return of();
            }
            )
        )
    })

    fetchEventBooking$ = createEffect(() => {
        return this.action$.pipe(
            ofType(adminActions.getEventBooking),
            concatLatestFrom(action => this.store.select(selectAdminEvent(action.eventRef))),
            switchMap(([action,data]) => {
                return this.service.getEventBooking(data!.eventID, action.bookingId).pipe(
                    map(booking => adminApiActions.fetchEventBooking({ update: {
                        id: data!.eventID,
                        changes: {
                            eventBookings: [...data?.eventBookings.filter(x => x.bookingID != action.bookingId ) ?? [], booking],
                        }
                    } }))
                )
            })
        )
    })
    
}